import Vue from 'vue';

import router from '../router';
import axios from 'axios';

export default {
	setSesion(user) {
		localStorage.setItem(Vue.prototype.$SESION, JSON.stringify(user));
	},

	getUser() {
		return JSON.parse(localStorage.getItem(Vue.prototype.$SESION)) || {};
	},

	redirectHome() {
		router.push('/legajos');
	},

	redirectFirstLogin() {
		router.push('/primerLogin');
	},

	redirectLogin() {
		router.push('/');
	},

	async getToken() {
		const token = this.getUser().Data ? this.getUser().Data.token : '';

		// Validación del token.
		const response = await axios
			.post('/users/check-auth-token', { token })
			.then((res) => res.data);
		if (response.isValid) {
			return token;
		} else {
			this.logout();
		}
	},

	async tokenExists() {
		const token = this.getUser().Data ? this.getUser().Data.token : '';
		return Boolean(token);
	},

	isAuthenticated() {
		return Object.keys(this.getUser()).length !== 0;
	},

	logout() {
		localStorage.removeItem(Vue.prototype.$SESION);
		this.redirectLogin();
	},

	async getHeader() {
		const token = await this.getToken();

		if (token) {
			const HEADER = { headers: { Authorization: Vue.prototype.$bearer + token } };
			return HEADER;
		} else {
			return '';
		}
	}
};
